import React, { Component } from 'react';
import {connect} from 'react-redux';
import { appUrl } from '../../AppConfig.js';
import * as Constants from '../Redux/action_types/EPAConstants.js';
//import { refArchSession, refArchBOM } from '../../State/actions/sessions';
import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import Paragraph from 'grommet/components/Paragraph';
import Anchor from 'grommet/components/Anchor';
import CloseIcon from 'grommet/components/icons/base/FormClose';
import Table from 'grommet/components/Table';
import TableRow from 'grommet/components/TableRow';
import Layer from 'grommet/components/Layer';
const HPE_CP_ = 'HPE Ezmeral Runtime Enterprise'; 

let Doc=[
         {
           Name:"HPE Reference Architecture for real-time streaming analytics with HPE Elastic Platform for Analytics (EPA) and MapR Data Platform (MapR)",
           Url:" https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00066812enw"
         },
         {
           Name:"HPE Reference Architecture for Apache Spark 2.1 on HPE Elastic Platform for Big Data Analytics (EPA)",
           Url:" https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00041363enw"
         },
         {
           Name : "HPE Reference Architecture for running analytics and data science workloads on BlueData EPIC platform",
           Url : "http://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00077915enw",
           workloadType : Constants.HPE_CP
         },
          {
            Name : "HPE Reference Configuration for delivering a Self-Service Experience: Running Analytics, Data Science and AI/ML workloads on the BlueData EPIC Platform",
            Url : "http://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00072257enw",
            workloadType : Constants.HPE_CP
          },
          {
            Name : "HPE Reference Configuration for enabling GPU-as-a-Service for Enterprise AI deployments with BlueData",
            Url : "http://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00078919enw",
            workloadType : Constants.HPE_CP
          },
          {
            Name : "HPE Reference Configuration for "+Constants.HPE_E_CPDESC+" on HPE Edgeline Converged Edge Systems",
            Url : "https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a50001287enw",
            workloadType : Constants.HPE_CP
          },
          {
            Name : "HPE Reference Configuration for Red Hat OpenShift Container Platform 4 on HPE Synergy",
            Url : "https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a50001254enw",
            workloadType : Constants.HPE_CP
          },
          {
            Name : "HPE Reference Configuration for "+Constants.HPE_E_CPDESC+" on HPE Apollo Gen10 Servers",
            Url : "https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a50001145enw",
            workloadType : Constants.HPE_CP
          },
          {
            Name : "HPE Reference Configuration for "+Constants.HPE_E_CPDESC+" on HPE Synergy",
            Url : "http://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a50001072enw",
            workloadType : Constants.HPE_CP
          },
         {
           Name:"HPE Reference Configuration for HPE AI Data Node",
           Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00065979enw"
         },
         {
           Name:"HPE Reference Configuration for Elastic Platform for Big Data Analytics (EPA)",
           Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-8931ENW"
         },
         {
           Name:"HPE Reference Configuration for MapR on HPE Elastic Platform for Big Data Analytics (EPA)",
           Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00048919enw"
         },
         {
           Name:"HPE Reference Configuration for Hortonworks Data Platform on HPE Elastic Platform for Big Data Analytics (EPA)",
           Url:" https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00043453enw"
         },
         {
           Name:"HPE Reference Configuration for Fast Data Analytics on Mesosphere DC/OS",
           Url:" https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00036351enw"
         },
         {
           Name:"HPE Reference Configuration for MapR on HPE Apollo 4200",
           Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00055864enw"
         },  
          {
           Name:"HPE Reference Architecture for AI on HPE Elastic Platform for Analytics (EPA) with TensorFlow and Spark",
           Url:" https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00060456enw"
         },
          {
           Name:"HPE Reference Architecture for Apache Spark 2.1 on HPE Elastic Platform for Big Data Analytics (EPA)",
           Url:"     https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00041363enw"
         },
          {
           Name:"HPE Reference Configuration for Cloudera Enterprise on HPE Elastic Platform for Big Data Analytics (EPA)",
           Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00042050enw"
         },
          {
           Name:"HPE Reference Configuration for the Elastic Platform for Big Data Analytics: ProLiant DL300-series modular building blocks of compute and storage optimized for modern workloads",
           Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00005869enw"
         },
          {
           Name:"HPE Reference Configuration for networking best practices on the HPE Elastic Platform for Big Data Analytics (EPA) Hadoop ecosystem",
           Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00004216enw"
         },
          {
           Name:"HPE Reference Architecture for MapR Converged Data Platform on HPE Elastic Platform for Big Data Analytics (EPA)",
           Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00020201enw"
         },
         {
           Name:"HPE Reference Configuration for Big-Data-as-a-Service with "+Constants.HPE_E_CPDESC+" software: Accelerating Big Data infrastructure deployments on HPE Elastic Platform for Big Data Analytics (EPA)",
           Url:"    https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-7823ENW"
         },
         {
           Name:"HPE Reference Configuration for HBase on HPE Elastic Platform for Big Data Analytics (EPA)",
           Url:"     https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA5-8757ENW"
         },
         {
           Name:"Spark - A modern data processing framework for cross platform analytics: Deploying Spark on HPE Elastic Platform for Big Data Analytics",
           Url:"    https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-8143ENW"
         },
         {
           Name:"HPE Reference Architecture for SAP HANA Vora with Spark and Hadoop: Using HPE ConvergedSystem for SAP HANA and HPE Elastic Platform for Big Data Analytics",
           Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-7739ENW"
         },
         {
           Name:"HPE Reference Architecture for SAP HANA Vora with Hortonworks HDP",
           Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-8601ENW"
         },
         {
           Name:"HPE Reference Architecture for Hortonworks HDP 2.4 on HPE Apollo 4200 Gen9 servers",
           Url:"  https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-7444ENW"
         },
         {
           Name:"HPE Reference Architecture for Hortonworks HDP 2.4 on HPE ProLiant DL380 Gen9 servers",
           Url:"      https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA5-9017ENW"
         },
         {
           Name:"HPE Reference Architecture for Hadoop on HPE Elastic Platform for Big Data Analytics (EPA): Deploying Hortonworks HDP with HPE Workload and Density Optimized (WDO) system                   ",
           Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA5-6136ENW"
         },
         {
           Name:"HPE Reference Architecture for Cloudera Enterprise 5.7 with HPE Apollo 2000 and HPE Apollo 4200 Gen9 servers                   ",
           Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-3366ENW"
         },
         {
           Name:"HPE Reference Architecture for Cloudera Enterprise 5 on HPE ProLiant DL380 Gen9 servers                           ",
           Url:" https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA5-9086ENW"
         },
         {
          Name:"HPE Reference Architecture for Cloudera Enterprise 5 on HPE Apollo 4200 Gen9 servers       ",
           Url:"   https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-6588ENW"
         }
         


         ]

class AdditionalReferenceComponent extends Component {
   
   constructor(props){
      super(props);
      this.state = { 
                     WhatsnewJson: '',                    
                   };
      this.closePopUps=this.closePopUps.bind(this);  
      //this.callRAContent = this.callRAContent.bind(this);
   }
// componentDidMount()
//   {
//     if(this.props.SupportedComponents === null)
//         this.props.OnFetchSupportedList(); 
//   }
   closePopUps(e){
        this.props.click();
   }
//    componentWillReceiveProps(nextProps){
//       // RABOM

//       if(nextProps.activeSession.id!="") {      
//         if(nextProps.activeSession.id !== this.props.activeSession.id){
//           if(nextProps.activeSession.treeView !== ''){
//             var obj = "";
//             obj = nextProps.activeSession.workload;            
//             this.props.onNewSession(obj);
//             this.props.redirectTo('/Build/SolnAlternative');
//             // this.props.history.push('/Build/SolnAlternative');
//           }else{
//             // var obj ="";              
//             // obj = nextProps.activeSession.workload;                
//             // this.props.onNewSession(obj);          
//             // this.props.redirectTo(interviewScreens[0].path);
//             // this.props.history.push('/Build/ContactInfo');
//           }    
//         }

//         if(nextProps.referenceArchitectBOM !== this.props.referenceArchitectBOM){
//           // nextProps.referenceArchitectBOM
//           var newWindow = window.open();
//           newWindow.document.write(nextProps.referenceArchitectBOM);
//         }
//       }
//    }

  //  callRAContent(obj){
  //       this.props.onRAClick( obj );
  //  }

   render() {
      let RefArchList;
      var sizerName = "EPA"

    // if( this.props.referenceArchitect !== undefined && this.props.referenceArchitect !== '' ){
      RefArchList = Doc.map( (val,id) => {
        var shouldBeinReferenceArchitecture = false;
        if ((appUrl.toUpperCase().indexOf(Constants.HPECP_SIZER.toUpperCase()) > -1 && val["workloadType"] === Constants.HPE_CP) || (appUrl.toUpperCase().indexOf(Constants.HPECP_SIZER.toUpperCase()) === -1 && val["workloadType"] !== Constants.HPE_CP)) {
          shouldBeinReferenceArchitecture = true;
        }
        if(shouldBeinReferenceArchitecture) {
          return(
                 <TableRow key={id.toString()}>
                           <td className='secondary'> <Anchor style ={{cursor:'pointer'}} onClick={() => window.open(decodeURIComponent(val["Url"]))}  > {val["Name"]} </Anchor> </td>
                           {/* <td className='secondary'> <Anchor primary={true} onClick={ () => { this.props.onRAClick({"UserId":"Madhukar", "Architecture": val["Name"], "Option": "Solution",  }) } } > Customize this RA Solution </Anchor> </td>
                           <td className='secondary'> <Anchor primary={true} onClick={ () => { this.props.onRAClick({"UserId":"Madhukar", "Architecture": val["Name"], "Option": "BOM",  }) } } target="_blank"> BOM (Bill of Material) </Anchor> </td>*/}
                 </TableRow>
          );
        }
      } );
     //}
    if (appUrl.toUpperCase().indexOf(Constants.HPECP_SIZER.toUpperCase()) > -1) {
      sizerName = HPE_CP_;
    }
    let content = '';
   // if( this.props.referenceArchitect !== undefined && this.props.referenceArchitect !== '' ){
      content =  <Layer className="ReferececeArchitcture" style={{width:'50%',height:'50%'}}>
                                <Box direction="column" margin="none" pad="none" style={{overFlow: "hidden"}}>
                                    <Box direction="row" colorIndex="neutral-1" margin="none" pad="small" separator="bottom">
                                          <Box direction="row" margin="none" pad="none" align='start' style={{width:'96%'}}>
                                               <Heading tag="h4"strong={true} style={{marginBottom:'0px',color:'#01a982'}}>Reference Architecture</Heading>
                                          </Box>
                                          <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.closePopUps} >
                                               <CloseIcon colorIndex="light-2" className="CloseIconStyle" />
                                          </Box>
                                    </Box>
                                    <Box margin="none" pad="small" style={{overflow: "auto"}} >
                                            <Heading tag="h6" strong={true} style={{margin:'4px 0px'}}>Learn More</Heading>
                                            <Paragraph style={{margin:'2px 0px', maxWidth:'100%'}}>HPE has produced {sizerName} collateral (white papers, technical articles etc.) that provide information on reference configurations.HPE recommends that you consult the information sources provided by clicking on the URL below to learn more.</Paragraph>
                                            <Table style={{margin:'4px 0px', overflow:'initial'}} selectable={false}>
                                                <tbody>
                                                  {RefArchList}
                                                </tbody>
                                            </Table>
                                    </Box>
                                </Box>
                               </Layer>
        
   // }else{
     //   content = '';
   // }
    return (
        <Box margin="none" pad="none">{ content }   </Box>
    );

   }
}

const mapStateToProps = (state) => {  
   return{
      // activeSession: state.sessions.activeSession,
      // DefaultInputs: state.sessions.sessionDefaults.inputs.Sizers.Sizer,
      // referenceArchitect: state.sessions.sessionDefaults.inputs.Sizers.Sizer.ReferenceArchitecture,
      // referenceArchitectBOM: state.sessions.RABOM,
      // SupportedComponents:state.sizerWorkload.supportedList,
   };
};

const mapDispatchToProps = (dispatch) => {
  return {
      // onRAClick : (data) => {
      //     if( data["Option"] === "BOM" ) {
      //       dispatch( refArchBOM (data) );
      //     }else if( data["Option"] === "Solution" ) {
      //       dispatch( refArchSession(data) );
      //     }
      // },
      
      // onNewSession:(workload) => {
      //   dispatch({ type:'UPDATE_SIZER_WORKLOAD', payload: workload })
      // },
      

  };
};

export default connect(mapStateToProps,mapDispatchToProps)(AdditionalReferenceComponent);



// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/ReferenceArchitecture.js